import { Box } from '@cad-arc';
import { colors } from '../colors/colors';

export const EDITABLE_BORDER_RADIUS_STYLES_WHEN_HAS_EVENT_NOTIFICATION =
    '0px var(--arc-radii-md) var(--arc-radii-md) 0px';

export function EventNotificationsFieldIndicator(props: {
    onClick: () => void;
    inFlexParent?: boolean;
}) {
    return (
        <Box
            onClick={props.onClick}
            cursor="pointer"
            alignSelf="stretch"
            w="8px"
            bg={colors.eventNotificationsFieldIndicatorBackground}
            borderRadius="var(--arc-radii-md) 0px 0px var(--arc-radii-md)"
        />
    );
}
